import React from "react";

const aboutData = [
  {
    title: "What Makes Us Different",
    text: (
      <>
        At Kyra Green Energy Solution, we focus on quality, reliability, and
        customer satisfaction:
        <ul className="list-disc pl-6 space-y-3 text-gray-800 text-base md:text-lg leading-relaxed mt-4">
          <li>
            <strong>Authorized Distributors –</strong> We bring products from top
            brands including Fujiyama, Eastman, Addos Solar, and Vsole.
          </li>
          <li>
            <strong>Comprehensive Solutions –</strong> From solar panels and
            inverters to energy storage systems, EV services, and full EPC
            execution.
          </li>
          <li>
            <strong>Premium 720W Panels –</strong> High-efficiency panels for
            residential, commercial, and industrial projects.
          </li>
          <li>
            <strong>Tailored Services –</strong> Custom-designed solutions that
            meet specific energy needs and space requirements.
          </li>
          <li>
            <strong>End-to-End Support –</strong> From consultation and
            installation to maintenance and long-term monitoring.
          </li>
        </ul>
      </>
    ),
    image: "/about1.png",
    alt: "Solar Panel Discussion",
    reverse: false,
  },
  {
    title: "Our Team",
    text:
      "Our team consists of experienced engineers, technicians, and renewable energy specialists who are passionate about delivering high-quality, sustainable energy solutions. We work closely with our customers and partners to ensure optimal performance, efficiency, and long-term value.",
    image: "/about2.png",
    alt: "Team Collaboration on Solar Design",
    reverse: true,
  },
  {
    title: "Why Choose Kyra Green Energy Solution?",
    text: (
      <>
        <p className="text-gray-800 text-base md:text-lg leading-relaxed mb-4">
          Choosing us means partnering with a company that prioritizes
          technology, reliability, and customer trust. We are committed to
          providing:
        </p>
        <ul className="list-disc pl-6 space-y-3 text-gray-800 text-base md:text-lg leading-relaxed">
          <li>Scalable solar solutions for every requirement</li>
          <li>High-performance inverters and storage systems</li>
          <li>Expert EPC services for seamless project execution</li>
          <li>Dealer and distributor support for long-term business growth</li>
          <li>Dedicated after-sales service to ensure energy systems perform at their best</li>
        </ul>
      </>
    ),
    image: "/about3.png",
    alt: "Handshake over solar models",
    reverse: false,
  },
  {
    title: "Our Commitment",
    text:
      "We are dedicated to transforming energy consumption patterns by offering sustainable and innovative solutions. At Kyra Green Energy Solution, every project is handled with precision, expertise, and care, ensuring maximum energy savings, efficiency, and environmental benefits for our clients.",
    image: "/about2.png",
    alt: "Hands united over solar model",
    reverse: true,
  },
];

const AboutBlock = ({ title, text, image, alt, reverse, isList }) => (
  <div
    className={`grid grid-cols-1 md:grid-cols-2 gap-10 items-center`}
  >
    {/* Image */}
    <div className={`flex justify-center ${reverse ? "md:order-2" : ""}`}>
      <img
        src={image}
        alt={alt}
        
      />
    </div>

    {/* Content */}
    <div className={`flex flex-col ${reverse ? "md:order-1" : ""}`}>
      <h2 className="text-brand-green text-3xl md:text-4xl font-extrabold mb-2">
        {title}
      </h2>

      <div className=" rounded-2xl shadow-sm  p-5 md:p-6">
        {isList ? (
          <ul className="list-disc pl-6 space-y-3 text-gray-800 text-base md:text-lg leading-relaxed">
            {text.map((item, index) => (
              <li key={index}>
                <strong>{item.split(":")[0]}:</strong> {item.split(":")[1]}
              </li>
            ))}
          </ul>
        ) : typeof text === "string" ? (
          <p className="text-gray-800 text-base md:text-lg leading-relaxed">{text}</p>
        ) : (
          text
        )}
      </div>
    </div>
  </div>
);

const About = () => {
  return (
    <>
 <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center  max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-8">
          {/* Heading */}
          <h1 className="text-brand-green text-2xl sm:text-3xl md:text-5xl leading-snug sm:leading-normal">
About Us – Kyra Green Energy Solution          </h1>
          
        </div>
      </div>

      {/* Intro Section */}
      <section className="bg-white px-4 md:px-16 lg:px-48 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="flex flex-col justify-center text-justify">
            <h2 className="text-3xl md:text-4xl font-extrabold text-brand-green mb-6">
              Who We Are
            </h2>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-4">
              Kyra Green Energy Solution is a leading renewable energy company
              committed to delivering clean, reliable, and cost-effective power
              solutions. We specialize in providing solar panels, inverters,
              energy storage systems (ESS), electric vehicle solutions, and
              complete EPC services for residential, commercial, and industrial
              applications.
            </p>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              With partnerships with trusted brands such as Fujiyama, Eastman,
              Addos Solar, and Vsole, we ensure that our customers receive
              high-quality products combined with expert service. Our goal is to
              make renewable energy accessible, efficient, and sustainable for
              everyone.
            </p>
          </div>

          <div className="flex justify-center items-center">
            <img
              src="/panel-set.png"
              alt="Solar Panel"
              
            />
          </div>
        </div>

        {/* Mission + Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-16">
          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold text-brand-green mb-6">
              Our Mission
            </h3>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-4">
              Our Mission is to empower homes and businesses with clean energy
              solutions that reduce electricity costs, increase energy
              independence, and contribute to a greener planet. We strive to
              deliver:
            </p>
            <ul className="list-disc pl-6 space-y-3 text-gray-700 text-base md:text-lg leading-relaxed">
              <li>High-Efficiency Solar Solutions</li>
              <li>Advanced Storage and Inverter Technologies</li>
              <li>Reliable EPC Services With Expert Project Execution</li>
              <li>Exceptional Support For Both End-Users And Dealers/Distributors</li>
            </ul>
          </div>

          <div>
            <h3 className="text-3xl md:text-4xl font-extrabold text-brand-green mb-6">
              Our Vision
            </h3>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed">
              To become a trusted leader in renewable energy solutions,
              providing innovative and sustainable technology that transforms
              the way people consume and store energy. We aim to lead the
              transition to a cleaner and smarter energy future for India and
              beyond.
            </p>
          </div>
        </div>
      </section>

      {/* Dynamic About Blocks */}
      <section className="bg-gradient-to-br from-green-50 via-white to-green-100 px-6 md:px-20 py-20 md:py-28 flex flex-col gap-20">
        {aboutData.map((block, index) => (
          <AboutBlock key={index} {...block} />
        ))}
      </section>
    </>
  );
};

export default About;
